<template>
	<v-footer role="contentinfo">
		<v-container>
			<p>{{text.line1}}</p>
			<p>{{text.line2}}</p>
			<p><span v-html="`${text.line3}`"></span><router-link :to="`${text.line3linkTarget}`">{{text.line3linkText}}</router-link>{{text.line3end}}</p>
			<v-layout justify-center space-around class="footer-links">
				
			</v-layout>
		</v-container>
	</v-footer>
</template>
<style>
.theme--light.v-footer {
  background: #ed145c;
  color:#ffffff;
}
footer.v-footer {height:auto !important}
footer p { text-align:center; font-size:12px}

footer a,footer a:hover,footer a:visited,footer a:link{ 
  color:#fff; 
  height:12px; 
  line-height:12px;
  font-size:12px;
  text-decoration:none;
  }

  footer .footer-links a,footer .footer-links a:hover,footer .footer-links a:visited,footer .footer-links a:link{ 
    padding:0px 5px; 
    border-right: 1px solid #fff;
  }
  footer a:hover{
    text-decoration:underline;
  }
  footer .footer-links a.end-item{ 
    border-right: none; 
  }
  @media screen and (max-width:420px){
    .layout.footer-links.justify-center.space-around{
      display:block;
    }
    footer .footer-links a, footer .footer-links a:hover, footer .footer-links a:visited, footer .footer-links a:link{ 
      padding:5px 0px 10px;
      text-align:center;
      display:block; 
      border-right: 0px solid #fff;
      border-bottom: none;
      margin-bottom:10px;
      text-decoration:underline;
    }
  }
</style>
<script>
  export default {
	props:['text', 'links'],
    data: () => ({
      
    })
  }
</script>